var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.links.length)?_c('MetaLinks',{attrs:{"header":"Vendere casa a:","url":"href","label":"slug","links":_vm.links,"show-on-close":"15"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }